export interface DashboardSession {
  team_id: string | null;
}

export const dashboard_session_initial_values: DashboardSession = {
  team_id: null,
};
